import * as React from "react";
import { connect } from "react-redux";
import { GlobalState } from "../../../store";
import { User, Activity, Link as LinkClass } from "../../../api/classes";
import {
  Avatar,
  Typography,
  IconButton,
  Tooltip,
  Input
} from "@material-ui/core";
import { Link } from "react-router-dom";
import TeyitLinkIcon from "@material-ui/icons/Bookmark";
import WebIcon from "@material-ui/icons/Link";
import CaseLink from "../components/link";
import SendIcon from "@material-ui/icons/Send";
import { DubitoSvc } from "src/api";
import { hasPermissionOf } from "src/auth/auth";
import { Permissions } from "src/api/constants";
import EmptyState from "src/components/emptyState";

interface Props {
  case_id: number;
  links: LinkClass[];
  onUpdate: () => void;
  style?: React.CSSProperties;
}
class CaseLinks extends React.Component<Props> {
  state = {
    url: ""
  };
  addLink = () => {
    /* TeyitLinkSvc.archive({ request_url: this.state.url }).then(res => {
      console.log(res);
    }); */
    DubitoSvc.addLink({
      case_id: this.props.case_id,
      url: this.state.url
    }).then(res => {
      this.setState({ url: "" });
      this.props.onUpdate();
    });
  };
  onDelete = (link: LinkClass) => {
    DubitoSvc.deleteLink({
      case_id: this.props.case_id,
      link_id: link.id
    }).then(res => {
      this.props.onUpdate();
    });
  };
  render() {
    const { links, style } = this.props;
    const canEdit = hasPermissionOf(Permissions.EDIT_CASES);
    return (
      <div style={{ marginLeft: 12 }}>
        {canEdit && (
          <div
            style={{
              display: "flex",
              padding: 12,
              backgroundColor: "#F4F1EE",
              borderRadius: 8
            }}
          >
            <Input
              style={{
                backgroundColor: "white",
                borderRadius: 24,
                marginRight: 12,
                marginTop: 4,
                marginBottom: 4,
                paddingLeft: 12,
                paddingTop: 12,
                flex: 1
              }}
              multiline
              value={this.state.url}
              onChange={e => this.setState({ url: e.target.value })}
              inputProps={{
                flex: 1
                // verticalTextAlign: "center"
              }}
              disableUnderline
              placeholder="Type the link"
            />
            <IconButton onClick={this.addLink}>
              <SendIcon />
            </IconButton>
          </div>
        )}
        {links.length === 0 ? (
          <EmptyState message="There is no link yet" />
        ) : (
          this.props.links.map(a => {
            return (
              <CaseLink
                key={a.id}
                link={a}
                onDelete={canEdit ? this.onDelete : undefined}
              />
            );
          })
        )}
      </div>
    );
  }
}
function mapStateToProps(state: GlobalState, own: Props) {
  return {};
}
function mapDispatchToProps(dispatch) {
  return {};
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CaseLinks);



// WEBPACK FOOTER //
// ./src/pages/cases/detail/link.tsx